import React, {Component} from 'react';
import "./footer.scss";

class Footer extends Component {
    render() {
        return (
            <footer>
                <div className="text-container">
                    <div className="text">Website DEVELOPMENT BY <a href="https://michaelrichardwalker.com" target="_blank" rel={"noreferrer"}>Michael Walker</a></div>
                    <div className="text"> <span className={"desktop-only"}>ALL IMAGES ARE COPYRIGHT </span> © Staser creative, LLC 2020</div>
                </div>
                <div className="icon-container">
                    <a target={"_blank"} rel={"noreferrer"} href={"https://www.instagram.com/stasercreative/"} className="icon">
                        <svg viewBox="0 0 109 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="54.5" cy="54.5" r="54.5" fill="#F1534B"/>
                            <rect x="22" y="22" width="65" height="65" rx="19" fill="white"/>
                            <rect x="28" y="28" width="53" height="53" rx="13" fill="#F1534B"/>
                            <path d="M71 54.5C71 63.6127 63.6127 71 54.5 71C45.3873 71 38 63.6127 38 54.5C38 45.3873 45.3873 38 54.5 38C63.6127 38 71 45.3873 71 54.5ZM43.6503 54.5C43.6503 60.4921 48.5079 65.3497 54.5 65.3497C60.4921 65.3497 65.3497 60.4921 65.3497 54.5C65.3497 48.5079 60.4921 43.6503 54.5 43.6503C48.5079 43.6503 43.6503 48.5079 43.6503 54.5Z" fill="white"/>
                            <circle cx="72" cy="37" r="4" fill="white"/>
                        </svg>
                    </a>
                    <a href={"mailto: laurenstaser@gmail.com"} className="icon">
                        <svg viewBox="0 0 109 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="54.5" cy="54.5" r="54.5" fill="#F1534B"/>
                            <path d="M44 55L26 75.5H83.5L65 55L55 64L44 55Z" fill="white"/>
                            <path d="M40.5 52L23 37V72L40.5 52Z" fill="white"/>
                            <path d="M69 52L86.5 37V72L69 52Z" fill="white"/>
                            <path d="M84.5 32H24.5L55 58L84.5 32Z" fill="white"/>
                            <path d="M44 55L26 75.5H83.5L65 55L55 64L44 55Z" />
                            <path d="M40.5 52L23 37V72L40.5 52Z" />
                            <path d="M69 52L86.5 37V72L69 52Z" />
                            <path d="M84.5 32H24.5L55 58L84.5 32Z" />
                        </svg>
                    </a>
                </div>
            </footer>
        );
    }
}

export default Footer;